import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TimelineSection = () => {
  const [expandedEvent, setExpandedEvent] = useState(null);

  const timelineStations = [
    {
      id: 1,
      date: "05 - 20 يناير",
      title: "الترشح والاستقبال",
      summary: "الإعلان الرسمي عن شروط ومعايير الترشح وفتح باب استلام الطلبات",
      description: `الإعلان الرسمي عن شروط ومعايير الترشح.
فتح باب استلام الطلبات لرئاسة الهيئة العمومية.
فتح باب استلام الطلبات للهيئات (الرقابية، الإدارية، والأمانة العامة).
إغلاق باب الترشح وحصر الملفات المبدئية.`,
      icon: "FileText",
      color: "text-primary",
      bgColor: "bg-primary/10"
    },
    {
      id: 2,
      date: "21 - 30 يناير",
      title: "التدقيق والاعتماد القانوني",
      summary: "فحص الملفات وإعلان القوائم والبت في الطعون",
      description: `فحص الملفات ومطابقتها للشروط من قبل الهيئة الانتخابية.
إعلان القوائم الأولية وفتح باب الطعون والاعتراضات.
البّت القانوني في الطعون (إن وُجدت).
إعلان "القائمة النهائية" للمرشحين وبدء فترة الصمت الانتخابي.`,
      icon: "CheckCircle",
      color: "text-accent",
      bgColor: "bg-accent/10"
    },
    {
      id: 3,
      date: "31 يناير",
      title: "الانعقاد والمكاشفة",
      summary: "عرض التقارير والمناظرات وعرض البرامج الانتخابية",
      description: `عرض التقرير المالي والإداري للدورة السابقة (إخلاء المسؤولية).
مناقشة وإقرار تعديلات النظام الداخلي.
جلسة المناظرات وعرض البرامج الانتخابية للمرشحين أمام الهيئة الناخبة.`,
      icon: "Users",
      color: "text-success",
      bgColor: "bg-success/10"
    },
    {
      id: 4,
      date: "01 فبراير",
      title: "الاقتراع والحسم",
      summary: "انطلاق جولات التصويت والفرز وإعلان النتائج",
      description: `انطلاق جولات التصويت المتتالية (مجلس الإدارة، الهيئة الرقابية، الهيئة العمومية).
الفرز العلني للأصوات ومطابقة النتائج.
إعلان التشكيلة القيادية الجديدة وتسليم المهام.`,
      icon: "Vote",
      color: "text-primary",
      bgColor: "bg-primary/10"
    }
  ];

  const toggleExpanded = (eventId) => {
    setExpandedEvent(expandedEvent === eventId ? null : eventId);
  };

  return (
    <section id="timeline" className="py-16 lg:py-24 bg-[#114845]/3">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="font-memorial text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4" dir="rtl">
            مسار التجديد المؤسسي: من الترشح إلى استلام المهام
          </h2>
          <p className="font-body text-lg md:text-xl text-text-primary leading-relaxed max-w-3xl mx-auto mt-6" dir="rtl">
            صُممت مراحل العملية الانتخابية لضمان انتقال القيادة بانسيابية تامة، وفق آليات تضمن شفافية الإجراءات، وتتيح المجال لوصول الكفاءات الأقدر على تحمل المسؤولية.
          </p>
        </motion.div>

        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-border"></div>

          <div className="space-y-8">
            {timelineStations.map((station, index) => (
              <motion.div
                key={station.id}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                className="relative"
              >
                {/* Timeline Dot */}
                <div className={`absolute left-6 w-4 h-4 ${station.bgColor} border-2 border-background rounded-full flex items-center justify-center`}>
                  <div className={`w-2 h-2 ${station.color.replace('text-', 'bg-')} rounded-full`}></div>
                </div>

                {/* Event Card */}
                <div className="ml-16 bg-card border border-border rounded-lg shadow-memorial overflow-hidden">
                  <div className="p-6">
                    <div className="flex items-start justify-between mb-4">
                      <div className="flex items-center space-x-4">
                        <div className={`w-10 h-10 ${station.bgColor} rounded-lg flex items-center justify-center`}>
                          <Icon name={station.icon} size={20} className={station.color} />
                        </div>
                        <div>
                          <p className="font-body text-sm text-text-secondary" dir="rtl">
                            {station.date}
                          </p>
                          <h3 className="font-body text-lg md:text-xl font-semibold text-primary" dir="rtl">
                            {station.title}
                          </h3>
                        </div>
                      </div>
                    </div>

                    <p className="font-body text-text-secondary mb-4" dir="rtl">
                      {station.summary}
                    </p>

                    {expandedEvent === station.id && (
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3 }}
                        className="border-t border-border pt-4 mb-4"
                      >
                        <p className="font-body text-text-primary leading-relaxed whitespace-pre-line" dir="rtl">
                          {station.description}
                        </p>
                      </motion.div>
                    )}

                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => toggleExpanded(station.id)}
                      iconName={expandedEvent === station.id ? 'ChevronUp' : 'ChevronDown'}
                      iconPosition="right"
                    >
                      {expandedEvent === station.id ? 'اقرأ أقل' : 'اقرأ المزيد'}
                    </Button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TimelineSection;
